module.exports = __webpack_public_path__ + "img/bg_11.6f3d4228.jpg";